module.exports = __webpack_public_path__ + "img/ep6-10.7602c383.png";